var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 14C11.9111 14 10.5362 13.7 9.17533 13.1C7.81444 12.5 6.57822 11.6444 5.46667 10.5333C4.35511 9.42222 3.49956 8.18889 2.9 6.83333C2.30044 5.47778 2.00044 4.1 2 2.7V2H5.93333L6.55 5.35L4.65 7.26667C4.89444 7.7 5.16667 8.11111 5.46667 8.5C5.76667 8.88889 6.08889 9.25 6.43333 9.58333C6.75556 9.90556 7.10844 10.214 7.492 10.5087C7.87556 10.8033 8.28933 11.0782 8.73333 11.3333L10.6667 9.4L14 10.0833V14H13.3Z",
    fill: "#6A6565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelePhone);
export default __webpack_public_path__ + "static/media/telePhone.47463ace393e9f98913e6c106af6cd59.svg";
export { ForwardRef as ReactComponent };